module.exports = __webpack_public_path__ + "static/media/home-image2.f8b888ec.jpg";